import { useMemo } from "react";
import { useCockpitStore } from "./store.js";
import { readRenderedThemePalette } from "./theme.js";

export const useThemePalette = () => {
  const resolvedTheme = useCockpitStore((state) => state.resolvedTheme);
  const palette = useMemo(() => readRenderedThemePalette(), [resolvedTheme]);
  return { isLight: resolvedTheme === "light", palette, resolvedTheme };
};
